'use client';
import type { Metadata } from "next";
import "./globals.css";
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';

function NavBar() {
  const router = useRouter();
  const pathname = usePathname();
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setEmail(localStorage.getItem('ff_email'));
    }
  }, [pathname]);

  const handleLogout = () => {
    localStorage.removeItem('ff_token');
    localStorage.removeItem('ff_email');
    router.replace('/login');
  };

  const isLoginPage = pathname === '/login';

  return (
    <nav className="nav-bar">
      <Link href="/" className="nav-logo">
        🔍 FotoForenzika
      </Link>
      <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        {!isLoginPage && (
          <>
            <Link href="/admin" style={{ color: '#a0a0a0', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>Admin</Link>
            <Link href="/settings" style={{ color: '#a0a0a0', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500 }}>Nastavitve</Link>
            <a href="/dashboard" className="btn-primary" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}>Analiza slik</a>
            {email ? (
              <>
                <span style={{ color: '#6b7280', fontSize: '0.82rem' }}>{email}</span>
                <button
                  onClick={handleLogout}
                  style={{
                    padding: '0.4rem 0.8rem', fontSize: '0.82rem', cursor: 'pointer',
                    background: 'rgba(248,113,113,0.08)', color: '#f87171',
                    border: '1px solid rgba(248,113,113,0.3)', borderRadius: '6px',
                    fontWeight: 600,
                  }}
                >
                  Odjava
                </button>
              </>
            ) : (
              <Link href="/login" style={{ color: '#6366f1', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 600 }}>
                Prijava
              </Link>
            )}
          </>
        )}
      </div>
    </nav>
  );
}

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="sl">
      <head>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      </head>
      <body>
        <NavBar />
        {children}
      </body>
    </html>
  );
}
